// extracted by mini-css-extract-plugin
module.exports = {"list":"contentList_list__pLbG8","bulleted":"contentList_bulleted__7a6K6","hide":"contentList_hide__MKB0N"};